import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ProvisionApplePayRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ProvisionApplePayResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const provisionApplePay = (request: ProvisionApplePayRequest, options?: CashRequestOptions) =>
  post<ProvisionApplePayRequest, ProvisionApplePayResponse>('/2.0/cash/provision-apple-pay', request, {
    ...options,
    rejectOnError: true,
  })
